import catalog from './fluRecommendCatalog.json';
import {createStageRecommendations} from './stageRecommendations';

const {getQuestion} = createStageRecommendations(catalog);
const normalize = text => String(text || '').toLowerCase().replace(/[\s？?。，,!！]/g, '');
const byIndex = new Map(catalog.questions.map(q => [q.index, q]));
const phase = q => catalog.modules.findIndex(m => m.id === q?.moduleId);
const lastPhase = catalog.modules.length - 1;
const userQuestions = history => (history || []).filter(m => m.role === 'user');
const inferPhase = history => {
    for (const m of [...userQuestions(history)].reverse()) {
        const q = catalog.questions.find(q => normalize(q.question) === normalize(m.content));
        if (q) return phase(q);
    }
    return 0;
};

function select(history, current, slots, preferred = [], selectedIndex = null, limit = 3) {
    if (limit <= 0) return [];
    const lastAsked = new Map(userQuestions(history).map((m, i) => [normalize(m.content), i]));
    const latest = userQuestions(history).slice(-1)[0];
    const blocked = new Set([normalize(latest?.content), normalize(byIndex.get(selectedIndex)?.question)]);
    const pool = [...preferred, ...catalog.questions].filter((q, i, all) => all.findIndex(x => x.index === q.index) === i);
    const chosen = [];
    const add = q => {
        if (!q || chosen.length >= limit || chosen.some(x => x.index === q.index) || blocked.has(normalize(q.question))) return;
        chosen.push(q);
    };
    const available = q => !lastAsked.has(normalize(q.question)) && !chosen.some(x => x.index === q.index) && !blocked.has(normalize(q.question));
    for (const p of slots) add(pool.find(q => phase(q) === p && available(q)));
    const phases = [...new Set([current, current + 1, current - 1, ...catalog.modules.map((_, i) => i)])];
    for (const p of phases) for (const q of pool) if (phase(q) === p && available(q)) add(q);
    // Only revisit old questions after exhausting every unasked candidate.
    const revisits = [...pool].sort((a, b) => (lastAsked.get(normalize(a.question)) ?? -1) - (lastAsked.get(normalize(b.question)) ?? -1));
    revisits.forEach(add);
    return chosen;
}

function getQuestions(history, limit = 3, selectedIndex = null) {
    if (limit <= 0) return [];
    if (!userQuestions(history).length && !byIndex.has(selectedIndex)) return catalog.initialIndices.map(i => byIndex.get(i)).slice(0, limit);
    const current = byIndex.has(selectedIndex) ? phase(byIndex.get(selectedIndex)) : inferPhase(history);
    return select(history, current, [Math.min(current + 1, lastPhase), Math.min(current + 1, lastPhase), current], [], selectedIndex, limit);
}

function completeFreeText(result, history, limit = 3) {
    const preferred = Array.isArray(result) ? result.map(getQuestion).filter(Boolean) : [];
    const declared = catalog.modules.findIndex(m => m.id === result?.[0]?.recommendation_stage);
    const current = declared >= 0 ? declared : preferred.length ? phase(preferred[0]) : inferPhase(history);
    return select(history, current, [current, current + 1, current - 1], preferred, null, limit);
}
export default {getQuestion, getQuestions, completeFreeText};
